import {
  GET_IMAGES_SUCCESS,
  SET_TRANSLATE_VALUE,
  SET_INDEX,
  TOGGLE_AUTOPLAY
} from "./types";
import axios from "axios";

/* Thunks */
export function getSliderImages() {
  return async dispatch => {
    try {
      const res = await axios.get(`/api/sliders`);
      let slides = res.data;
      slides = slides.map(item => {
        item.content = JSON.parse(item.content);
        return item;
      });
      // let res = await axios.get('./slider-config.json')
      // let res = [
      //   Slider1,
      //   Slider2,
      //   Slider3
      // ];
      dispatch(getImagesSuccess(slides));
    } catch (e) {
      console.error("Fetching images failed: " + e);
    }
  };
}
/* Action Creators */
export function getImagesSuccess(images) {
  return {
    type: GET_IMAGES_SUCCESS,
    payload: images
  };
}
export function setTranslateValue(value) {
  return {
    type: SET_TRANSLATE_VALUE,
    payload: value
  };
}
export function setIndex(value) {
  return {
    type: SET_INDEX,
    payload: value
  };
}
export function toggleAutoplay(isActive) {
  return {
    type: TOGGLE_AUTOPLAY,
    payload: isActive
  };
}
